import React from "react";

import "react-tippy/dist/tippy.css";
import { Helmet } from "react-helmet";

import logo from "./images/Logo provincie Zuid-Holland.svg";
import slogan from "./images/Krachtig Zuid-Holland.svg";
import dataPages from "./data/pages";



const Page = (props) => {
    
    const pageData = dataPages.pages.filter(page => page.url === props.path);

    // console.log(pageData);

    return (
    <div className="container">
      <header>
        <Helmet>
          <title>{pageData[0].title} • PlanMER • Provincie Zuid-Holland</title>
          <meta name="description" content={pageData[0].description} />
          <meta property="og:image" content={"."+pageData[0].image} />
        </Helmet>
        <div className="wrapperFull">
          <a href="/" className="logo">
            <img src={logo} alt="Provincie Zuid-Holland" />
          </a>
          <div className="headerMenu">
          </div>
        </div>
      </header>
      <div className="pageTitle">
        <div className="wrapper">
          <div className="row">
            <div className="col-6">
              <h1>{pageData[0].title}</h1>
              <div className="versienummer">Versie {pageData[0].date}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="wrapper">
          <div className="row">
            <div className="col-4">
                <div dangerouslySetInnerHTML={ {__html: pageData[0].text} } />

                {pageData[0].links.map(links => <><a href={links.btn_url} target="_blank" rel="noreferrer" key={links.btn_tekst} className="btn">{links.btn_tekst}<i className="fa fa-external-link"></i></a></>)}
            </div>
            <div className="col-2">
                <div className="image_mask"><img src={'..'+ pageData[0].image} alt={pageData[0].title} /></div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="wrapper">
          <div className="motto">
            <img src={slogan} alt="Krachtig Zuid-Holland" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Page;
